export default function useScrollToTop() {
  const scrollToTop = (element) => {
    if (!element) return;

    element.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return scrollToTop;
}
